import Api, { apiPaths } from "app/services/api";

class UploadFilesService {
  upload(file, fileInfo, onUploadProgress) {
    let formData = new FormData();

    formData.append("file", file);

    for (const key in fileInfo) {
      if (Object.hasOwnProperty.call(fileInfo, key)) {
        const element = fileInfo[key];
        formData.append(key, element)
      }
    }

    return Api.fileUpload(formData, onUploadProgress)
    // return http.post("/upload", formData, {
    //   headers: {
    //     "Content-Type": "multipart/form-data",
    //   },
    //   onUploadProgress,
    // });
  }

  delete(uuid) {
    return Api.delete(`${apiPaths.FILE}/${uuid}`)  
  }

  getFiles() {
    // return http.get("/files");
  }
}

export default new UploadFilesService();